import { ChangeEventHandler } from "react";
import styles from "./SwitchRadioButton.module.css";
interface IsWitchProps {
  text?: string;
  checked?: boolean;
  isWithBg?: boolean;
  onChange?: ChangeEventHandler<any> | undefined;
  className?: string;
}

const SwitchRadioButton: React.FC<IsWitchProps> = ({
  text,
  checked,
  onChange,
  className,
  isWithBg,
}) => {
  return (
    <label
      className={`inline-flex w-full cursor-pointer items-center justify-start gap-4 self-stretch p-3 ${isWithBg ? "rounded-lg border bg-primary-bg transition-all duration-300 hover:bg-primaryLight" : ""}`}
    >
      <div className="flex shrink grow basis-0 items-center justify-between">
        {text && <span className={` ${checked ? "" : className}`}>{text}</span>}
        <input
          type="checkbox"
          className={styles.checkbox}
          checked={checked}
          onChange={onChange}
        />
        <div className={styles.switch}></div>
      </div>
    </label>
  );
};

export default SwitchRadioButton;
